import http from './http'
import {
	CalendarEvent,
	CalendarEventRequestData,
	CreateCalendarEventReqData,
} from '../types/calendar'
import { AppApiResponseData } from '../types/api'
import { AxiosPromise } from 'axios'

export function getCalendarEvents(
	data: CalendarEventRequestData
): AxiosPromise<AppApiResponseData<Array<CalendarEvent>>> {
	return http({
		method: 'POST',
		url: `/p/calenderEvents`,
		data,
	})
}

export function deleteEvent(eventId: string): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'DELETE',
		url: `/p/calenderEvent/${eventId}`,
	})
}

export function create(
	data: CreateCalendarEventReqData
): AxiosPromise<AppApiResponseData<CalendarEvent<Array<string>>>> {
	return http({
		method: 'POST',
		url: '/p/calenderEvent',
		data,
	})
}

export function update(
	data: CreateCalendarEventReqData,
	eventId: string
): AxiosPromise<AppApiResponseData<CalendarEvent<Array<string>>>> {
	return http({
		method: 'PUT',
		url: `/p/calenderEvent/${eventId}`,
		data,
	})
}

export function getForPatient(
	patientId: string
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'GET',
		url: `/p/calenderEvent/future/${patientId}`,
	})
}
